<template>
  <div>
    <div
      id="jobIntentionModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          ref="letter"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">職缺意願</div>

              <div class="note-title">可動態套入信件內容，請參考以下參數</div>
              <div class="note-table">
                <table v-if="mailParameters">
                  <tr v-for="(parameter, index) in mailParameters" :key="index">
                    <th>{{ parameter.MailParameterName }}</th>
                    <td>
                      <span> {{</span>{{ parameter.MailParameterCode
                      }}<span>}} </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <perfect-scrollbar class="modal-body">
                  <div class="form-group">
                    <label for="">姓名：</label>
                    <span>{{ mail.Interviewee }}</span>
                  </div>

                  <div class="form-group">
                    <label for="">職缺：</label>
                    <el-select
                      class="w-100"
                      multiple
                      filterable
                      placeholder="請選擇"
                      v-model="mail.ManpowerDemandNos"
                    >
                      <el-option
                        v-for="opening in openingOptions"
                        :key="opening.ManpowerDemandNo"
                        :label="opening.ManpowerDemandName"
                        :value="opening.ManpowerDemandNo"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="form-group">
                    <label for="">附件：</label>
                    <el-upload
                      class="upload-demo"
                      action
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="uploadFile"
                    >
                      <el-button size="small" type="primary">
                        點擊上傳
                      </el-button>
                    </el-upload>
                    <template v-if="uploadFileList">
                      <div v-for="file in uploadFileList" :key="file.FileGuid">
                        <p
                          style="margin-top: 20px; cursor: pointer"
                          @click="
                            $common.downloadFile({
                              fileGuid: file.FileGuid,
                              fileType: file.FileContentType,
                            })
                          "
                        >
                          <eva-icon fill="#000" name="attach-outline" />
                          <span
                            style="margin-left: 15px; vertical-align: text-top"
                          >
                            {{ file.FileName }}
                          </span>
                          <span
                            style="
                              display: inline-block;
                              position: absolute;
                              right: 25px;
                            "
                            @click.stop="
                              removeFile({
                                fileGuid: file.FileGuid,
                                fileGroupGuid: file.FileGroupGuid,
                              })
                            "
                          >
                            <eva-icon fill="#000" name="trash-2-outline" />
                          </span>
                        </p>
                      </div>
                    </template>
                  </div>

                  <div class="form-group">
                    <label for=""> 信件範本： </label>
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      placeholder="請選擇"
                      @change="getMailTemplateDetail"
                      v-model="selectedTemplateGuid"
                    >
                      <el-option
                        v-for="template in mailTemplates"
                        :key="template.MailTemplateGuid"
                        :label="template.MailTemplateName"
                        :value="template.MailTemplateGuid"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件主旨"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件主旨： </label>
                      <input
                        placeholder="請輸入信件主旨或選擇範本"
                        class="form-control w-100"
                        v-model="mail.MailSubject"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件內容"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件內容： </label>
                      <VueEditor
                        style="background: rgb(255, 255, 255)"
                        v-model="mail.MailTemplateBody"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                </perfect-scrollbar>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="closeJobIntentionModal"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(preview)"
                  >
                    預覽
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    :disabled="clickDisabled"
                    @click="handleSubmit(sendInterviewInvitation)"
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <!-- 預覽 Modal -->
    <PreviewMailModal type="job" :mail="mail" />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
// 預覽信件
import PreviewMailModal from "@/components/back/Modal/PreviewMailModal.vue";

export default {
  props: ["personData"],

  name: "JobIntentionModal",
  components: {
    PreviewMailModal,
  },
  data() {
    return {
      // 職缺
      openingOptions: [],

      // 範本
      mailParameters: {},
      mailTemplates: [],

      // 所選擇範本的 guid
      selectedTemplateGuid: null,

      // 信件內容
      mail: {},

      // 寄出按鈕
      clickDisabled: false,

      // 附件
      fileGroupGuid: "",
      resetFileStatus: true, // 第一次必為 true
      uploadFileList: [], // 上傳附件列表
    };
  },

  computed: {
    ...mapGetters(["showJobIntentionMail"]),
  },

  watch: {
    showJobIntentionMail: function (e) {
      if (e) {
        this.selectedTemplateGuid = null;
        this.mail = {
          Interviewee: this.personData.Name,
          ResumeIds: [this.personData.ResumeId],
        };
        this.fileGroupGuid = "";
        this.resetFileStatus = true;
        this.uploadFileList = [];
        this.$refs.letter.reset();
        this.clickDisabled = false;
        $("#jobIntentionModal").modal("show");
      } else {
        $("#jobIntentionModal").modal("hide");
      }
    },
  },

  methods: {
    // 上傳 檔案
    uploadFile(file) {
      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", this.fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.fileGroupGuid = response.data;
          this.resetFileStatus = false;
          this.getFileList(this.fileGroupGuid);
        }
      });
    },

    // 取得附件
    getFileList(fileGroupGuid) {
      const vm = this;
      const api = `${window.endpoints.api}/FileUpload/GetFileDetails/${fileGroupGuid}`;

      const params = {
        resetFileStatus: vm.resetFileStatus,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          vm.uploadFileList = response.data.filter((item) => !item.IsDelete);
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "附件取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 刪除附件
    removeFile({ fileGuid, fileGroupGuid }) {
      const vm = this;
      const api = `${window.endpoints.api}/FileUpload/RemoveFile/${fileGuid}`;

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .put(api)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "附件刪除成功",
              type: "success",
              duration: 1000,
            });
            vm.$nextTick(function () {
              vm.uploadFileList = [];
              vm.resetFileStatus = false;
              vm.getFileList(fileGroupGuid);
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 職缺意願
    sendInterviewInvitation() {
      this.clickDisabled = true;
      this.updateLoading(true);

      this.$api.sendmail
        .jobIntention({
          ...this.mail,
          MailSenderGuid: this.$cookies.get("userId"),
          FileGroupId: this.fileGroupGuid ? this.fileGroupGuid : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.clickDisabled = false;
            this.updateLoading(false);
            this.$store.commit("OpenJobIntentionModal", false);
            this.$notify({
              title: "成功",
              message: "已寄出職缺意願信件",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch(() => {
          this.clickDisabled = false;
          this.updateLoading(false);
        });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplateDetail(this.selectedTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$set(
              this.mail,
              "MailSubject",
              response.data.MailTemplateSubject
            );
            this.$set(
              this.mail,
              "MailTemplateBody",
              response.data.MailTemplateBody
            );
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    preview() {
      this.$store.commit("OpenPreviewMailModal", true);
    },

    // 點擊取消
    closeJobIntentionModal() {
      this.$store.commit("OpenJobIntentionModal", false);
    },

    async getData() {
      await this.$http
        .all([
          this.$api.opening.getOpening(),
          this.$api.mailTemplate.getMailParameter(
            "5dbb37fe-16a8-429d-bb6a-2fa246856dec"
          ),
          this.$api.mailTemplate.getMailTemplatePaging(
            { isPaging: false },
            "JobIntention"
          ),
        ])
        .then(
          this.$http.spread((opening, parameter, template) => {
            // 取得 職缺選項
            this.openingOptions = opening.data.map((item) => {
              return {
                ManpowerDemandNo: item.ManpowerDemandNo,
                ManpowerDemandName: item.ManpowerDemandName,
              };
            });
            // 取得 信件參數
            this.mailParameters = parameter.data;
            // 取得 信件範本
            this.mailTemplates = template.data.Datas;
          })
        );
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenJobIntentionModal", false);
  },
};
</script>

<style lang="scss" scoped>
#jobIntentionModal {
  .modal-dialog {
    max-width: 960px;
    .modal-content {
      background-color: transparent;
      border: none;
    }
  }
}
</style>
